import { joinLetterFileRoom } from "@/app/router/join-letter-file-room.middleware.ts";
import { useLetterFileStore } from "@/app/stores/letter-file.store.ts";
import { useLoadingStore } from "@/app/stores/loading.store.ts";
import { usePastaRouter } from "@pasta/box-v2";
import { watch } from "vue";
import type { RouteRecordNameGeneric } from "vue-router";

export default function syncCurrentLetterFile(routeName: RouteRecordNameGeneric) {
  const router = usePastaRouter();
  const loadingStore = useLoadingStore();

  watch(
    () => router.vueRouter.currentRoute.value.params.chrono,
    async () => {
      loadingStore.setLoading("set-lf", true);
      const store = useLetterFileStore();
      const chrono = router.vueRouter.currentRoute.value.params.chrono as string;
      if (!chrono) return;

      try {
        const letterFile = await store.fetchOneByChrono(chrono);
        store.setCurrentId(letterFile.id);
      } catch (e: any) {
        if (e.statusCode === 404) {
          if (router.vueRouter.currentRoute.value.name === routeName) {
            router.push({ name: "error", query: { type: "LF_NOT_FOUND" } });
          } else {
            router.push({ name: "error", query: { type: "NOT_FOUND" } });
          }
        } else if (e.statusCode === 403) {
          router.push({ name: "fluxerror" });
        } else {
          router.push({ name: "error" });
        }
      }

      await joinLetterFileRoom(store.currentId);
      loadingStore.setLoading("set-lf", false);
    },
    { immediate: true }
  );
}
